import script from "./CustomizeMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomizeMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CustomizeMenu.vue?vue&type=style&index=0&id=8624e40a&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8624e40a"]])

export default __exports__